import { PropsWithChildren, ReactElement, useEffect, useRef, useState } from "react";
import { useAuth } from "./auth_provider";
import { initTranslation } from "i18n/i18n";
import i18next from "i18next";

export const I18nProvider = ({ children }: PropsWithChildren): ReactElement => {
  const { authData } = useAuth();
  const initStarted = useRef(false);
  const [i18nReady, setI18nReady] = useState(i18next.isInitialized);

  useEffect(() => {
    if (!authData?.isAuthenticated || initStarted.current) return;

    initStarted.current = true;

    if (i18next.isInitialized) {
      setI18nReady(true);
      return;
    }

    i18next.on("initialized", () => setI18nReady(true));
    initTranslation();
  }, [authData?.isAuthenticated]);

  if (!i18nReady) return <></>;

  return <>{children}</>;
};
